import images from "../../ImageVariables";
import { MFApropsTypes } from "../MFApropsTypes";
import "../SCSS/styles.css";
export default function MFA({
  emailId,
  assessmentName,
  otp,
  handelOtpChange,
  activeOTPIndex,
  inputRef,
  handleOnkeyDown,
  handleVerifyOTP,
  handleResendOTP,
  otpError,
  handleOtpPaste,
}: MFApropsTypes) {
  return (
    <div className="mfa-container">
      <div className="mfa-image">
        <img className="otp-img" src={images.otpScreen} alt="otp" />
      </div>
      <div className="mfa-assessment-name">{assessmentName}</div>
      <div className="mfa-header">ENTER VERIFICATION CODE</div>
      <div className="mfa-description">
        We have just sent a verification code to
        <span className="email-id">{emailId}</span>
      </div>
      <div className="enter-input-field-cover">
        {otp.map((_, index) => {
          return (
            <div className="input-field" key={index}>
              <input
                className={
                  otp[index] || otpError
                    ? `input-number ${otpError ? "error" : "no-error"}`
                    : "input-no-number"
                }
                ref={index === activeOTPIndex ? inputRef : null}
                type="number"
                onChange={(event) => handelOtpChange(event)}
                onKeyDown={(event) => handleOnkeyDown(event, index)}
                onPaste={handleOtpPaste}
                value={otp[index]}
              />
            </div>
          );
        })}
      </div>
      {otpError && <span className="otp-error">{otpError}</span>}
      {/* <div className="mfa-timer">Time remaining 02:00</div> */}
      <div className="mfa-resend-otp-cover">
        Didn't receive code?
        <button className="resend-btn" onClick={() => handleResendOTP()}>
          Resend OTP
        </button>
      </div>
      <div className="verify-button-cover">
        <input
          className="verify-button"
          type="button"
          value="VERIFY & PROCEED"
          onClick={() => handleVerifyOTP()}
        />
      </div>
    </div>
  );
}
